var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpIco7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emp-ico-7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.793,
    height: 14.793,
    viewBox: "0 0 14.793 14.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M0,0H14.793V14.793H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M3,15.78H14.1V10.849A1.849,1.849,0,0,0,12.246,9h-7.4A1.849,1.849,0,0,0,3,10.849Z",
    transform: "translate(-1.151 -3.453)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    d: "M3,14.111a1.48,1.48,0,0,0,.616.121,1.479,1.479,0,0,0,1.233-.616A1.479,1.479,0,0,1,6.082,13a1.479,1.479,0,0,1,1.233.616,1.541,1.541,0,0,0,2.465,0,1.541,1.541,0,0,1,2.465,0,1.479,1.479,0,0,0,1.233.616,1.464,1.464,0,0,0,.616-.121",
    transform: "translate(-1.151 -4.987)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M11.233,4l.9,1.01a1.233,1.233,0,1,1-1.858.061Z",
    transform: "translate(-3.836 -1.535)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpIco7);
export default __webpack_public_path__ + "static/media/emp-ico-7.91707c3f4547e0d057a2a4a5969043ee.svg";
export { ForwardRef as ReactComponent };